<template>
  <div  @click="closeNotification" class="fixed top-6 h-fit w-11/12 m-auto flex justify-between p-4 hover:border border-black shadow-lg cursor-pointer" style="z-index: 9999;left: 50%;transform: translateX(-50%);" :class="isError ? 'hover:!bg-red' : 'hover:!bg-green'" :style="isError ? 'background-color:rgb(255, 0, 0, 0.8)' : 'background-color:rgb(81, 163, 81, 0.8)'">

    <img v-if="!isError" src="@/assets/img/cart.png" class="w-8 h-8 mr-2 my-auto" @click="closeNotification"/>
    <p class=" my-auto text-white">{{message}}</p>

    
    <img src="@/assets/img/closew.png" class="w-4 h-4 ml-2 my-auto color-white" @click="closeNotification"/>
  </div>
</template>

<script>
import { Field } from 'vee-validate'

export default {
  emits: ['closeNotification'],
  components: {
    Field
  },
  props: {
    message: [String],
    isError: [Boolean]
  },
  data: () => ({}),
  methods: {
    closeNotification(){
      this.$emit('closeNotification')
    },
  },
  computed: {
 
  }
}
</script>

<style scoped>
</style>
